import { render, staticRenderFns } from "./NewRouteItinerary.vue?vue&type=template&id=564f7cfa&"
import script from "./NewRouteItinerary.vue?vue&type=script&lang=js&"
export * from "./NewRouteItinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports